module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/db4e6476e6664d41bf7b5b6ca8e093db.gif";